import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import Text from 'components/Text/Text';
import style from './Loader.module.scss';

export const Loader: React.FC = () => {
	const { isLoading, uploadProgress } = useContext<IAppContext>(AppContext);
	const progressValue = uploadProgress ? Math.min(100, Math.max(0, Math.round(uploadProgress))) : 0;

	return (
		<>
			{isLoading ? (
				<div className={style.container} data-test="Loader">
					<div className={style.spinner}>
						<div />
						<div />
						<div />
						<div />
						<div />
						<div />
						<div />
						<div />
						<div />
						<div />
						<div />
						<div />
					</div>
					{!!progressValue && (
						<div className={style.percentWrapper} data-test="progress">
							<div className={style.percent}>
								{progressValue}
								<span className={style.percentSuffix}>%</span>
							</div>
							<div className={style.progressTrack}>
								<div className={style.progressFill} style={{ width: `${progressValue}%` }} />
							</div>
							<Text
								className={style.caption}
								translationNameSpace="global"
								translationKey="uploading"
								theme="neutralLight"
								align="center"
								size="xs"
							/>
						</div>
					)}
				</div>
			) : null}
		</>
	);
};
